/**
 * Resolves a value by country code, falling back to the product default for unknown,
 * null, or undefined values. Shared by the locale-dependent token resolvers.
 */
export function resolveByCountry<T>(country: string | undefined | null, usValue: T, auValue: T, productDefault: T): T {
    switch (country?.trim().toUpperCase()) {
        case 'US':
            return usValue;
        case 'AU':
            return auValue;
        default:
            return productDefault;
    }
}
